import jsona from '@/lib/jsona';
import VisnetHubs from '@/resources/visnet-hubs';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'substationVisnetHub';
const DEFAULT_STATE = {
  error: null,
  visnetHub: null,
  activeView: 'visnetHubDefaultCharts'
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    },
    parseResponseData(state, response) {
      state.visnetHub = jsona.deserialize(response);
    },
    setCurrentView(state, view) {
      state.activeView = view;
    }
  },
  actions: {
    fetchData({ commit }, visnetParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const { projectCode, substationCode, externalVisnetHubId } = visnetParams;

      VisnetHubs({ projectCode, substationCode })
        .get({
          code: externalVisnetHubId,
          include:
            'substation,substation.project,substation.feeder_info_cards,modem,ways,ways.diagrams'
        })
        .then(
          response => {
            commit('parseResponseData', response.data);
            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          },
          () => {
            RootStateCommit(commit, 'setResponseError', MODULE_NAME);
            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          }
        );
    },
    changeChartView({ commit }, { name }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      commit('setCurrentView', name);
      RootStateCommit(commit, 'stopLoading', MODULE_NAME);
    }
  },
  getters: {
    visnetHub: state => !!state.visnetHub && state.visnetHub,
    modem: state => !!state.visnetHub && state.visnetHub.modem,
    activeView: state => !!state.activeView && state.activeView,
    diagrams: state => !!state.visnetHub && [[], ...state.visnetHub.ways.map(way => way.diagrams)],
    feederDiagrams: (state, getters) => feederNumber => getters.diagrams[feederNumber + 1] || []
  }
};
